import React from 'react';
import { deals, popularDestinations } from '../mock/mock';
import DemoNotice from '../components/DemoNotice';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { TrendingDown, MapPin } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

export default function Deals() {
  const { toast } = useToast();
  return (
    <div>
      <section className="bg-gradient-to-br from-teal-700 to-teal-800 py-16 text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-amber-300 uppercase tracking-widest text-xs font-semibold">Holiday deals</div>
          <h1 className="font-display font-extrabold text-3xl md:text-5xl mt-2">Save more on your next trip</h1>
          <p className="text-white/85 mt-3 max-w-2xl">Editor-picked holiday packages, city breaks, cruises and long-haul deals — refreshed weekly.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="flex items-center gap-2 mb-6">
          <TrendingDown className="w-5 h-5 text-amber-500" />
          <h2 className="font-display font-extrabold text-2xl text-slate-900">This week&apos;s top deals</h2>
        </div>
        <DemoNotice className="mb-6" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {deals.map(d => (
            <Card key={d.id} className="overflow-hidden border-slate-200 card-lift">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={d.image} alt={d.title} className="absolute inset-0 w-full h-full object-cover" />
                <Badge className="absolute top-3 left-3 bg-amber-500 text-slate-900 border-0">-{d.savings}%</Badge>
              </div>
              <CardContent className="p-4">
                <div className="text-xs text-slate-500 flex items-center gap-1"><MapPin className="w-3 h-3" /> {d.location} · {d.nights} nights</div>
                <div className="font-display font-bold text-slate-900 mt-1">{d.title}</div>
                <div className="flex items-end justify-between mt-3">
                  <div>
                    <div className="text-[10px] uppercase tracking-widest text-slate-500">package from</div>
                    <div className="font-display font-extrabold text-xl text-teal-700">S${d.price}</div>
                  </div>
                  <Button className="bg-teal-700 hover:bg-teal-800 text-white font-semibold" onClick={() => toast({ title: 'Live booking partner integration in progress', description: `${d.title} is shown as part of our demonstration deals experience while we activate our travel partners.` })}>Grab deal</Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      <section className="bg-slate-50 border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
          <h2 className="font-display font-extrabold text-2xl text-slate-900 mb-6">Cheap flight deals from Singapore</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {popularDestinations.map(d => (
              <Card key={d.id} className="border-slate-200 card-lift">
                <CardContent className="p-4 flex items-center gap-3">
                  <img src={d.image} alt={d.city} className="w-14 h-14 rounded-lg object-cover" />
                  <div className="min-w-0">
                    <div className="text-xs text-slate-500">SIN → {d.code}</div>
                    <div className="font-display font-bold text-slate-900 truncate">{d.city}</div>
                    <div className="text-teal-700 font-extrabold">S${d.price}</div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
